export default __webpack_public_path__ + "b3ba65f5f8d6ea7730f5f9467d707e62.avif";